var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.251 18.51V.65h3.016V18.51H.251z",
    fill: "#ED2490"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.667H3.268V.651H19v3.016z",
    fill: "#5FBB46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.702v17.823h-3.016V3.667L19 3.702z",
    fill: "#FBA919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.251 18.509h15.733v3.016H.25V18.51z",
    fill: "#42B6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollageLogo);
export default __webpack_public_path__ + "static/media/collage-logo.a8225fbef223174ea56bd43c70c86c34.svg";
export { ForwardRef as ReactComponent };